import { customTextBlock, heading,
  paragraph,
  button } from "../../../text/nodes"
import { SponsorCTANoImage as SponsorCTANoImageEditor } from "./sponsor-cta-no-image"
import { SponsorCTANoImageSettings } from "./sponsor-cta-no-image-settings"
import SponsorCTANoImagePreview from "./sponsor-cta-no-image-preview.png"

export const SponsorCTANoImage = {
  name: "SponsorCTANoImage",
  label: "call to action on left, image on right",
  EditorComponent: SponsorCTANoImageEditor,
  SettingsComponent: SponsorCTANoImageSettings,
  image: SponsorCTANoImagePreview,
  defaultProperties: {
    backgroundColor: null,
    headingColor: "#303030",
    headingFontWeight: 700,
    textColor: "#4d4d4d",
    textFontWeight: 400,
    sponsorLabelColor: "#303030",
    sponsorLabelFontWeight: 700,
    image: "",
    alt: "",
    horizontalPadding: 0,
    verticalPadding: 30,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    imageBorderRadius: 0,
    borderColor: "#F2F2F2",
    borderTopWidth: 1,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 1
  },
  defaultChildren: [
    customTextBlock([
      paragraph("SPONSOR", {
        alignment: "left"
      })
    ]),
    customTextBlock([heading("three", "Sponsor title")]),
    customTextBlock([
      paragraph("Lorem ipsum dolor sit amet, conscet etur adipiscing elit."),
      button("Learn more", {
        alignment: "left",
        roundedCornerOption: "full",
        size: "small"
      })
    ])
  ]
}
